import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { StripeService, SubscriptionPlan } from '../services/stripe.service';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [CommonModule, CardModule, ButtonModule, ToastModule],
  providers: [MessageService],
  template: `
    <div class="settings-container">
      <p-toast></p-toast>
      <div class="settings-header">
        <h1>Settings</h1>
      </div>

      <div class="settings-content">
        <p-card header="Subscription" styleClass="subscription-card">
          <div class="subscription-status">
            <p><strong>Status:</strong> 
              <span [class.active]="subscriptionStatus === 'active'" 
                    [class.inactive]="subscriptionStatus !== 'active'">
                {{ subscriptionStatus | titlecase }}
              </span>
            </p>
          </div>

          <div class="subscription-actions" *ngIf="subscriptionStatus !== 'active'">
            <div *ngFor="let plan of plans" style="margin-bottom: 1rem;">
              <p><strong>{{ plan.name }}</strong> - $ {{ plan.price }}/{{ plan.billingInterval }}</p>
              <button pButton 
                label="Subscribe" 
                icon="pi pi-credit-card"
                [loading]="isRedirecting"
                (click)="onSubscribe(plan.stripePriceId)">
              </button>
            </div>
          </div>

          <div class="subscription-actions" *ngIf="subscriptionStatus === 'active'">
            <button pButton 
              label="Manage Subscription" 
              icon="pi pi-external-link"
              class="p-button-secondary"
              [loading]="isRedirecting"
              (click)="onManageSubscription()">
            </button>
          </div>
        </p-card>
      </div>
    </div>
  `,
  styles: [`
    .settings-container { padding: 2rem; max-width: 800px; margin: 0 auto; }
    .settings-header { margin-bottom: 2rem; }
    .settings-header h1 { font-size: 1.75rem; color: var(--text-color); margin: 0; }
    .subscription-status { margin-bottom: 1.5rem; font-size: 1.1rem; }
    .active { color: var(--green-600); font-weight: bold; }
    .inactive { color: var(--text-color-secondary); }
    .subscription-actions { display: flex; flex-direction: column; gap: 1rem; }
  `]
})
export class SettingsComponent implements OnInit {
  subscriptionStatus = 'none';
  isRedirecting = false;
  plans: SubscriptionPlan[] = [];

  constructor(
    private stripeService: StripeService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.stripeService.getSubscriptionStatus().subscribe({
      next: (res) => this.subscriptionStatus = res.status,
      error: (err) => console.error(err)
    });
    this.stripeService.getPlans().subscribe({
      next: (res) => this.plans = res,
      error: (err) => console.error(err)
    });
  }

  onSubscribe(priceId: string): void {
    this.isRedirecting = true;
    this.stripeService.createCheckoutSession(priceId).subscribe({
      next: (res) => { if (res.url) window.location.href = res.url; },
      error: (err) => {
        console.error(err);
        this.isRedirecting = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Checkout error.' });
      }
    });
  }

  onManageSubscription(): void {
    this.isRedirecting = true;
    this.stripeService.createPortalSession().subscribe({
      next: (res) => { if (res.url) window.location.href = res.url; },
      error: (err) => {
        console.error(err);
        this.isRedirecting = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Portal error.' });
      }
    });
  }
}
